import React from "react";
import Axios from 'axios'
import API from '../Utils/api'
import MasterTemplate from "./MasterTemplate";
import moment from 'moment';

export class MasterCaixasGerentes extends React.Component {
    constructor(props) {
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
        super(props);
        this.state = {
            user: JSON.parse(localStorage.getItem("user")),
            gerentes: [],
            gerenteSelecionado: null,
            verificado: false,
            filteredList: [],
            parametros: null
        };
        this.getTodosPedidos()
        this.getParametros()
    }

    deselecionarGerente() {
        this.setState({gerenteSelecionado: null})
        this.forceUpdate()
    }

    selecionarGerente(event) {
        this.setState({gerenteSelecionado: event.target.accessKey})
        this.forceUpdate()
    }


    formatDate(data) {
        return moment(data).add(0, 'days').format('DD-MM-YYYY')
    }

    verificarCaixas() {
        this.setState({
            ...this.state,
            verificado: true
        })
    }

    getUser = async (e) => {
        try {
            var axiosInstance = new Axios.create({baseURL: window.localStorage.getItem("apiUrl")});
            const response = await axiosInstance.post("usuarios/user", {id: this.state.user._id});

            window.localStorage.setItem("user", JSON.stringify(response.data[0]));
            this.setState({user: response.data[0]});
        } catch (err) {
            console.log(err);
        }
    };

    getParametros = async () => {
        var axiosInstance = new Axios.create({baseURL: window.localStorage.getItem("apiUrl")});
        const response = await axiosInstance.get('/parametros')
        this.setState({parametros: response.data})
    }


    listarGerentes = async (e) => {
        try {
            const response = await API.post("/api/usuarios/listar-todos-gerentes-ativos-minificado", {});
            this.setState({
                gerentes: response.data.sort(this.compararNome)
            });
            this.setState({filteredList: this.state.gerentes})
        } catch (err) {
            console.log(err);
        }
    };

    async getTodosPedidos() {
        try {
            const response = await API.post("/api/pedidos/caixa-gerentes-master", {});
            this.separPedidos(response.data)
        } catch (err) {
            console.log(err);
        }
    }

    separPedidos(pedidos) {
        var gerentes = {}
        pedidos.map(pedido => {
        if(pedido.gerenteId){
            if (gerentes[pedido.gerenteId._id] == undefined) {
                gerentes = {
                    ... gerentes,
                    [pedido.gerenteId._id]: {
                        pedidos: [],
                        cartelas: 0,
                        gerenteId: pedido.gerenteId._id,
                        nome: pedido.gerenteId.nome,
                        entradas: 0
                    }
                }
            }
            gerentes[pedido.gerenteId._id].entradas += pedido.cartelas.length * pedido.cartelas[0].valor;
            gerentes[pedido.gerenteId._id].cartelas += pedido.cartelas.length;
            gerentes[pedido.gerenteId._id].pedidos.push(pedido);
        }
        })
        this.setState({gerentes: Object.entries(gerentes).sort(this.compararNome2)})
    }

    efetuarReload() {
        window.location.reload()
    }
    async zerarTodosCaixa(e) {
        try {
            const response = await API.post("/api/transacoes/zerar-todos-caixas", {});
            alert("Cartelas validadas com sucesso!")
            window.location.reload()
        } catch (err) {
            console.log(err);
            alert("Caixas vazios!")
        }
    }

    async efetivarTransacoes(cambista) {
        try {
            const response = await API.post("/api/transacoes/zerar-caixa", {id: cambista._id});
        } catch (err) {
            console.log(err);
        }
    }

    compararNome(a, b) {
        if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
            return 1;
        }
        if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
            return -1;
        }

        return 0
    }

    compararNome2(a, b) {
        if (a[1].nome.toLowerCase() > b[1].nome.toLowerCase()) {
            return 1;
        }
        if (a[1].nome.toLowerCase() < b[1].nome.toLowerCase()) {
            return -1;
        }

        return 0
    }


    searchName(e) {
        var filteredList = this.state.gerentes.filter(usuario => {
            if (usuario != undefined && usuario.nome.toLowerCase().includes(e.target.value.toLowerCase())) {
                return usuario;
            }
        })

        this.setState({filteredList: filteredList})
    }

    render() {
        return (
            <MasterTemplate label={'Caixa Gerentes'}>

                <div class="modal w-50" id="exampleModal2"
                    style={
                        {marginLeft: '20em'}
                    }
                    tabindex="-1"
                    role="dialog">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Alerta</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <p>Validar todos os pedidos!</p>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn-fill btn btn-secondary" data-dismiss="modal">Cancelar</button>
                                <button type="button" data-dismiss="modal"
                                    onClick={
                                        this.zerarTodosCaixa.bind(this)
                                    }
                                    class="btn-fill btn btn-primary">Confirmar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card strpied-tabled-with-hover">
                                <div className="card-header ">
                                    <h4 className="card-title">Acompanhe caixa de seus gerentes</h4>
                                    <p className="card-category">Informações de movimentações.</p>
                                </div>
                                <div className="card-body table-full-width table-responsive">
                                    <div className="row pl-5 pr-5 justify-content-center">
                                        {/* <input className="form-control w-50" placeholder="busca rapida..." onChange={this.searchName.bind(this)}></input> */} </div>
                                    <div class="row">
                                        <div class="col"></div>
                                        <div class="col-sm"></div>
                                        <div class="col-sm"></div>
                                        <div class="col">
                                            <button data-toggle="modal" data-dismiss="modal" data-target="#exampleModal2"
                                                class={"ml-2 btn-fill btn btn-danger"}>Validar todos
                                            </button>
                                        </div>

                                    </div>
                                    <table className="table table-hover table-striped">
                                        <thead>
                                            <tr>
                                                <th>no.</th>
                                                <th>Nome</th>
                                                <th>Cartelas vendidas</th>
                                                <th>Entradas</th>
                                                <th>Comissões</th>
                                            </tr>
                                        </thead>
                                        <tbody> {
                                            this.state.gerentes.length > 0 ? this.state.gerentes.map((gerente, index) => {
                                                return (

                                                    <tr class="font-weight-bold">
                                                        <td>{
                                                            index + 1
                                                        }</td>
                                                        <td style={
                                                            {cursor: 'pointer'}
                                                        }>
                                                            {
                                                            gerente[1].nome
                                                        }</td>
                                                        <td style={
                                                            {cursor: 'pointer'}
                                                        }>
                                                            {
                                                            gerente[1].cartelas
                                                        }</td>
                                                        <td style={
                                                            {cursor: 'pointer'}
                                                        }>R$: {
                                                            parseFloat(gerente[1].entradas).toFixed(2)
                                                        }</td>
                                                        <td style={
                                                            {cursor: 'pointer'}
                                                        }>
                                                            R$: {
                                                            parseFloat(gerente[1].cartelas * this.state.parametros ?. baseComissaoGerente).toFixed(2)
                                                        } </td>
                                                    </tr>
                                                );
                                            }) : <div className="p-3 d-flex text-danger bold"
                                                style={
                                                    {
                                                        minWidth: '100%',
                                                        justifyContent: 'center'
                                                    }
                                            }>
                                                <span>TODOS OS PEDIDOS FORAM VALIDADOS!</span>
                                            </div>
                                        } </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </MasterTemplate>
        );
    }
}

export default MasterCaixasGerentes;
